export class UpdateProposalStatusDTO {
    ProposalId: number;
    GroupId: number;
    WorkflowStatusId: number;
    RejectReasonIds: number[];
    RejectionComment: string;
    IncompleteComments: string;
    PendingValidationComments: string;
    ApproveCommentForLowUtilization: string;
    MRPSolverFlag: boolean;
    IsServiceOptimized: boolean | null;
    IsConditionalApproval: boolean | null;
    EffectivityTo: Date;
    ConditionalApprovalMessage: string;
    UserBypassedActiveProposalWarning: boolean;
    constructor() {
        this.GroupId = 0;
    }
}
